import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/logos/12thplus-logo.svg" alt="12thPlus.com" className="logo-img" />
        </Link>

        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {mobileMenuOpen ? (
              <path d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path d="M3 12h18M3 6h18M3 18h18" />
            )}
          </svg>
        </button>

        <div className={`navbar-links ${mobileMenuOpen ? 'active' : ''}`}>
          <Link
            to="/"
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/students"
            className={`nav-link ${isActive('/students') ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Students
          </Link>
          <Link
            to="/institutions"
            className={`nav-link ${isActive('/institutions') ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Institutions
          </Link>
          <Link
            to="/careerexplorer"
            className={`nav-link nav-link-highlight ${isActive('/careerexplorer') ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Career Explorer
          </Link>
          <Link
            to="/about"
            className={`nav-link ${isActive('/about') ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            About
          </Link>
          <Link
            to="/contact"
            className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Contact
          </Link>
          <a href="https://12thplus.com/app/get-started" className="btn-signup">Get Started</a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
